import React from 'react';
import classnames from 'clsx';

import style from './premium-program-tag.module.css';
import { ChildrenPropType } from '../../prop-types/children';
import PropTypes from 'prop-types';

export const PremiumProgramTag = ({ className, children }) => {
  return <div className={classnames(style['premium-program-tag'], className)}>{children}</div>;
};

PremiumProgramTag.propTypes = {
  className: PropTypes.string.isRequired,
  children: ChildrenPropType.isRequired,
};
